import React, {Component} from 'react';

export default class Sidebar extends Component {
	render() {
		return (
			<footer className="footer footer-black  footer-white ">
				<div className="container-fluid">
					<div className="row">

						<div className="credits ml-auto">
              <span className="copyright">
                © {new Date().getFullYear()}, made with <i className="fa fa-heart heart"/> by internezzo
              </span>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/main/Footer.js